// extracted by mini-css-extract-plugin
export default {"container":"Separater_container__K2dlP","separater":"Separater_separater__CVYpo"};